import { axios } from "@/plugins/axios";
import { getDataString } from "@/utils";
import store from "@/store";

function getUserAddress() {
    return axios.post("?Mode=MeinServicebereich&Function=GetUserAddress");
}

function getProfessions() {
    return axios.post(
        "?Mode=General&Function=Beruf",
        "geschlecht=" + store.state.user.details.geschlecht
    );
}

function getTitles() {
    return axios.post("?Mode=General&Function=TitelV2");
}

function updateUserData(userData) {
    const dataString = getDataString(userData);
    return axios.post(
        "?Mode=MeinServicebereich&Function=UpdateUserData",
        dataString
    );
}

function changePassword(
    data = { passwordold: "", passwordnew: "", verfuegernummer: "" }
) {
    const dataString = getDataString(data);
    return axios.post(
        "?Mode=MeinServicebereich&Function=ChangePassword",
        dataString
    );
}

export {
    getUserAddress,
    getProfessions,
    getTitles,
    updateUserData,
    changePassword,
};
